<script lang="ts">
  import tagIcon from "../assets/tag.svg?raw";
    import { notifyWhenMounted } from "../tutorial/Tutorial";

  export let publicScene;

  let iconUrl: string | null = null;
  let iconTooltip: string | null = null;

  $: stringTags = publicScene.Tags.join(", ");
  $: if (publicScene) {
    if (publicScene.scene.metadata) {
      iconUrl = publicScene.scene.metadata.iconUrl;
      iconTooltip = publicScene.scene.metadata.iconTooltip;
    }
  }
</script>

<div
  class="scene-container border-solid-2px border-blue border-radius-pico-border-radius padding-1rem font-family-bardic-sans"
  style="background-image: url('{publicScene.BannerUrl}');"
  use:notifyWhenMounted
>
  <div>
    <div class="scene-title light">
      {publicScene.Name}
    </div>
    <div class="scene-tags">
      <span class="light width-1rem">{@html tagIcon}</span><span class="light"
        >{stringTags}</span
      >
    </div>
  </div>
  <div>
    {#if iconUrl}
      <div
        class="align-content-center no-tooltip-underline"
        data-tooltip={iconTooltip}
        data-placement="left"
      >
        <img class="outline-black scene-logo" src={iconUrl} alt={iconTooltip} />
      </div>
    {/if}
  </div>
</div>
